import  { useCallback, useEffect, useState, useRef } from "react";
import useColumn from "../../../utils/customHooks/useColumns";
import { useNavigate } from "react-router-dom";
import { GET_SPONSOR_INFOS, DELETE_SPONSOR_INFO } from "../../../utils/services/apiPath";
import usePageState from "../../../utils/customHooks/usePageState";
import { STAUTES } from "../../../utils/constant";
import { postApi, deleteApi } from "../../../utils/services";
import { errorToast, successToast } from "../../../utils/toastHelper";
import { useTheme } from "../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../store/features/auth/authSlice";
import logo from "../../Assets/Icons/logo.png";
import logoWhite from "../../Assets/Icons/logo-white.png";
import menuopen from "../../Assets/Icons/menu-open.png";
import menuclose from "../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../utils/MenusConfig";
import HelpMenu from "../../Components/Header/HelpMenu";
import { ProGrid, NameCell, DeleteCell, Layout } from "@proscore-ai/proscore-ui-library";
import useCsvExport from "../../../utils/useCsvExporter";

const getRedirectUrl = params => {
  return `/sponsor-info/${params.id}`;
};

export default function SponsorsInfoList() {
  const {
    currentPage,
    pageSize,
    data: sponsorInfoListData,
    rowCount,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const ref = useRef(null);
  const userData = useSelector(userSelector);
  const dispatch = useDispatch();

  const handleTabClick = tab => {
    navigate(`${tab.to}`);
  };
  const handleMenuOpen = () => setMenuOpen(!menuOpen);

  const onLogout = () => {
    dispatch(handleLogout());
  };

  const manageAccount = () => {
    setPopOverOpen(false);
  };

  const handleHome = () => {
    navigate("/clients");
  };
  const columns = useColumn([
    {
      field: "companyName",
      headerName: "Company Name",
      renderCell: params => <NameCell params={params} getRedirectUrl={getRedirectUrl} />
    },
    {
      field: "contactPhoneNumber",
      headerName: "Contact"
    },
    {
      field: "email",
      headerName: "Email"
    },
    {
      field: "sponsorInformationId",
      headerName: "Actions",
      isDeleteColumn: true,
      disableExport: true,
      width: 80,
      renderCell: params => <DeleteCell params={params} onDelete={onDelete} />
    }
  ]);

  const getSponsorInfoList = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const payload = {
      pageIndex: searchString ? 1 : currentPage + 1,
      pageSize: pageSize,
      searchString: searchString,
      orderByAscending: false,
      orderCol: "companyName",
      ...sortModel
    };
    const { data, totalRecords, error } = await postApi(GET_SPONSOR_INFOS, payload);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  const onDelete = async id => {
    const { error } = await deleteApi(DELETE_SPONSOR_INFO, { params: { sponsorInformationId: id } });
    if (error) return errorToast(error);
    successToast("Sponsor's Info deleted successfully");
    getSponsorInfoList();
  };

  const handleDownloadCSV = useCsvExport({
    api: GET_SPONSOR_INFOS,

    getPayload: () => {
      const activeSort = sortModel?.[0] || {
        field: "companyName",
        sort: "asc"
      };

      return {
        pageIndex: 1,
        pageSize: rowCount || 10000,
        searchString,
        orderByAscending: activeSort.sort === "asc",
        orderCol: activeSort.field
      };
    },

    mapData: data =>
      data.map(item => ({
        "Company Name": item.companyName || "",
        "Contact": item.contactPhoneNumber || "",
        "Email": item.email || ""
      })),

    fileName: "SponsorInfoList.csv"
  });

  useEffect(() => {
    getSponsorInfoList();
  }, [getSponsorInfoList]);

  const addButtonAction = () => {
    navigate(`/sponsor-info/add`);
  };

  return (
    <Layout
      theme={theme}
      user={{
        userName: userData?.userName,
        email: userData?.email,
        avatar: userData?.avatar
      }}
      onLogout={onLogout}
      onTabClick={handleTabClick}
      onLogoClick={handleHome}
      logo={logo}
      logoWhite={logoWhite}
      menuOpenIcon={menuopen}
      menuCloseIcon={menuclose}
      menuTabs={headerMenus}
      NotificationIcon={NotificationIcon}
      HelpComponent={HelpMenu}
    >
      <ProGrid
        title="Sponsor Information"
        columns={columns}
        rows={sponsorInfoListData}
        addButtonLabel="+ Add Sponsor Info"
        addButtonAction={addButtonAction}
        searchMode={!!searchString}
        searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
        options={{
          getRowId: row => row.sponsorInformationGuid,
          rowCount: rowCount,
          paginationMode: "server",
          paginationModel: { pageSize: pageSize, page: currentPage },
          onPaginationModelChange: setPagination,
          sortingMode: "server",
          onSortModelChange: setSortModel
        }}
        exportAction={handleDownloadCSV}
      />
    </Layout>
  );
}
